import { useMemo } from 'react'
import ElectionResultsLiveBoard from './ElectionResultsLiveBoard'
import VsMatchupLiveBoard from './VsMatchupLiveBoard'
import { ELECTION_DISPLAY_TOP_N, mapPopularityToElectionRows, type PopularityLike } from './electionBoardUtils'
import { isElectionCategory } from './predictionDisplayUtils'
import { mapPopularityToVersusDisplay } from './versusBoardUtils'
import type { PredictionDisplayConfig } from './predictionDisplayBackgroundUtils'

type Props = {
  category: string
  popularity?: PopularityLike | null
  title: string
  subtitle?: string
  footerTitle?: string
  footerNote?: string
  totalCandidates?: number
  updatedAt?: string
  maxRows?: number
  live?: boolean
  loading?: boolean
  displayConfig?: PredictionDisplayConfig | null
}

export default function PredictionDisplayBoard({
  category,
  popularity,
  title,
  subtitle,
  footerTitle,
  footerNote,
  totalCandidates,
  updatedAt,
  maxRows = ELECTION_DISPLAY_TOP_N,
  live = true,
  loading = false,
}: Props) {
  const electionMode = isElectionCategory(category)

  const electionRows = useMemo(() => {
    if (!electionMode || !popularity?.selections?.length) return []
    return mapPopularityToElectionRows(popularity, maxRows)
  }, [electionMode, popularity, maxRows])

  const versusData = useMemo(() => {
    if (electionMode || !popularity?.selections?.length) return null
    return mapPopularityToVersusDisplay(popularity)
  }, [electionMode, popularity])

  if (electionMode) {
    return (
      <ElectionResultsLiveBoard
        title={title}
        subtitle={subtitle || `Top ${maxRows} · realtime`}
        footerTitle={footerTitle}
        rows={electionRows}
        totalStake={popularity?.totalStake ?? 0}
        totalBets={popularity?.totalBets ?? 0}
        updatedAt={updatedAt ?? popularity?.updatedAt}
        totalCandidates={totalCandidates ?? popularity?.selections?.length}
        maxVisible={maxRows}
        live={live}
        loading={loading}
        emptyMessage="ยังไม่มีข้อมูลการวางเดิมพัน"
      />
    )
  }

  return (
    <VsMatchupLiveBoard
      title={title}
      subtitle={subtitle || '1 vs 1 · realtime'}
      footerTitle={footerTitle}
      footerNote={footerNote}
      data={versusData || { mainEvent: null, undercard: [], totalStake: 0, totalBets: 0 }}
      updatedAt={updatedAt ?? popularity?.updatedAt}
      live={live}
      loading={loading}
    />
  )
}
